import React from 'react';
import { stats } from '../mock';

const StatsBar = () => (
  <section className="px-4 md:px-10 pb-10">
    <div className="mx-auto max-w-[1240px] rounded-2xl border border-emerald-900/15 bg-white shadow-[0_2px_20px_rgba(4,45,25,0.06)] px-6 py-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((s, i) => (
          <div key={s.label} className={`text-center md:text-left ${i > 0 ? 'md:pl-6 md:border-l md:border-emerald-900/15' : ''}`}>
            <div className="font-serif text-3xl md:text-4xl text-emerald-950 tracking-tight">{s.value}</div>
            <div className="mt-1 text-[12px] uppercase tracking-[0.12em] text-emerald-700/70">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsBar;
